import React, { useState } from "react";
import "./Home.css";
import QuickCount from "./QuickCount";
import { Helmet } from "react-helmet";
const Home = () => {
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);

  const slides = [
    { src: "/images/1.png", alt: "Woods" },
    { src: "/images/2.png", alt: "Cinque Terre" },
    { src: "/images/3.png", alt: "Mountains and fjords" },
    { src: "/images/4.png", alt: "Northern Lights" },
  ];

  const nextSlide = () => {
    setCurrentSlideIndex((prevIndex) => (prevIndex + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlideIndex(
      (prevIndex) => (prevIndex - 1 + slides.length) % slides.length
    );
  };

  const currentSlide = (index) => {
    setCurrentSlideIndex(index);
  };

  return (
    <>
      <Helmet>
        <title>Home</title>
        <meta name="description" content="Discover expert interior design services for your home or office. Transform your space with style and functionality. Contact us for personalized solutions." />
        <meta name="keywords" content="interior design, home decor, modern interiors, office interiors, design solutions" />
      </Helmet>
      <div className="container">
        <div className="row">
          <div className="image-slide">
            {/* Full-width images with number text */}
            {slides.map((slide, index) => (
              <div
                key={index}
                className={`mySlides ${
                  currentSlideIndex === index ? "show" : ""
                }`}
              >
                <div className="numbertext">
                  {index + 1} / {slides.length}
                </div>
                <img
                  src={slide.src}
                  alt={slide.alt}
                  className="img-fluid carsoule-img"
                  style={{
                    width: "100%",
                    height: "400px",
                  }}
                />
                {/* Adding the icon */}
                <img
                  src="/images/sale3.png"
                  alt="Icon"
                  className="icon-top-right"
                />
              </div>
            ))}

            <a className="prev" onClick={prevSlide}>
              &#10094;
            </a>
            <a className="next" onClick={nextSlide}>
              &#10095;
            </a>

            <div className="caption-container">
              <p>{slides[currentSlideIndex].alt}</p>
            </div>

            <div className="row">
              {slides.map((slide, index) => (
                <div className="column" key={index}>
                  <img
                    className={`demo cursor image-fluid ${
                      currentSlideIndex === index ? "active" : ""
                    }`}
                    src={slide.src}
                    style={{ width: "100%", height: "100px" }}
                    onClick={() => currentSlide(index)}
                    alt={slide.alt}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      {/* container-2*/}
      <div className="container mt-4 mb-4">
        <div className="row">
          <h1 className="main-heading mb-4">WHAT WE DO </h1>
          <div className="col-xl-8 col-md-8 col-sm-8">
            <div className="bedroom">
              <h1 className="bedroom-text">Bedroom</h1>
            </div>
            <div className="row">
              <div className="col-xl-6 col-md-6 col-sm-6">
                <div className="kitchen mb-2">
                  <h1 className="kitchen-text">kitchen</h1>
                </div>
              </div>
              <div className="col-xl-6">
                <div className="living mb-2">
                  <h1 className="living-text">living</h1>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-4">
            <div className="dining mb-2">
              <h1 className="dining-text">dining</h1>
            </div>
          </div>
        </div>
      </div>
      {/* container-3 */}
      <div className="container mt-2">
        <div className="row">
          <h2 className="text-center second-heading mt-2">
            Our Love for <br />
            Interior Design
          </h2>
          <h5 className="about-heading">About Us</h5>
          <p className="text-center mt-2">
            We are a passionate team dedicated to creating stunning interiors.
          </p>
          <div className="col-xl-7 col-sm-7 col-lg-7">
            <div className="about-image">
              <img
                src="/images/about.png"
                style={{ width: "100%", height: "450px" }}
                className="img-fluid about-img"
              />
            </div>
          </div>
          <div className="col-xl-5 col-sm-5 col-lg-5">
            <h6 className="text-center mt-5 fs-4">
              We have extensive experience in interior design and a broad
              knowledge of the latest trends and techniques.
            </h6>
            <p className="mt-5">
              At mno , we blend creativity and functionality to transform
              spaces into stunning environments. Our team of passionate interior
              designers is dedicated to bringing your vision to life with
              personalized, stylish, and innovative solutions. Let us make your
              dream space a reality.
            </p>
            <button className="mybutton">About us</button>
          </div>
          <div className="number-count mt-4 mb-4 row">
            <div className="stat-item col-xl-3">
              <QuickCount limit={156} />
              <p className="text-center">PROJECTS DONE</p>
            </div>
            <div className="stat-item col-xl-3">
              <QuickCount limit={25} />
              <p className="text-center">OFFICE</p>
            </div>
            <div className="stat-item col-xl-3">
              <QuickCount limit={45} />
              <p className="text-center">PRO TEAMS</p>
            </div>
            <div className="stat-item col-xl-3">
              <QuickCount limit={700} />
              <p className="text-center">GLOBAL CLIENTS</p>
            </div>
          </div>
        </div>
      </div>
      {/* container-4 */}
      <div className="container">
        <div className="row text-center">
          <h2 className="second-heading mt-2">
            Expertly crafting <br /> your dream
          </h2>
          <h5 className="about-heading">Services</h5>
          <p className="mb-5">
            We turn your interior design dreams into reality with our
            specialized touch in elegant and functional spaces.
          </p>
        </div>
        <div className="row service-bg">
          {/* Left column - Image */}
          <div className="col-xl-8 col-lg-8 col-md-12 service-image">
            <img
              src="/images/service.png"
              style={{ width: "100%", height: "auto" }}
              className="img-fluid"
              alt="Service"
            />
          </div>
          {/* Right column - Service content */}
          <div className="col-xl-4 col-lg-4 col-md-12">
            <div className="service-content p-5">
              <h5 className="text-center">Residential</h5>
              <p className="text-center mb-3">Personalized home interiors</p>
              <h5 className="text-center">Planning</h5>
              <p className="text-center mb-3">Optimize Layout</p>
              <h5 className="text-center">Renovation</h5>
              <p className="text-center mb-3">Seamless space updates</p>
              <h5 className="text-center">Redesign</h5>
              <p className="text-center">Innovative transformations</p>
            </div>
            <div className="text-center">
              <button className="mybutton mb-5">Services</button>
            </div>
          </div>
        </div>
      </div>
      {/* ----------------container-5------------- */}
      <div className="container-fluid mt-5 showcase-bg">
        <div className="row">
          <h2 className="showcase-heading text-center">Showcase</h2>
          <h5 className="about-heading mb-3">Quiet Space</h5>
          <div className="col-xl-9 mb-2">
            <img
              src="/images/service.png"
              style={{ width: "100%", height: "350px" }}
              className="img-fluid"
            />
          </div>
          <div className="col-xl-3 mb-2">
            <img
              src="/images/sc1.png"
              style={{ width: "100%", height: "350px" }}
              className="img-fluid"
            />
          </div>
          <div className="col-xl-3 mb-2">
            <img
              src="/images/sc3.png"
              style={{ width: "100%", height: "350px" }}
              className="img-fluid"
            />
          </div>
          <div className="col-xl-9 mb-2">
            <img
              src="/images/sc4.png"
              style={{ width: "100%", height: "350px" }}
              className="img-fluid"
            />
          </div>
          <div className="col-xl-9 mb-2">
            <img
              src="/images/sc5.png"
              style={{ width: "100%", height: "350px" }}
              className="img-fluid"
            />
          </div>
          <div className="col-xl-3 mb-2">
            <img
              src="/images/sc6.png"
              style={{ width: "100%", height: "350px" }}
              className="img-fluid"
            />
          </div>
        </div>
      </div>
      {/* ----------container-6---------- */}
      <div className="container">
        <div className="row">
          <h2 className="text-center second-heading mt-2">Interior Process</h2>
          <h5 className="about-heading mb-3">Process</h5>
          <p className="text-center">
            Transforming a space involves understanding and applying key design
            principles to create a harmonious and functional environment.
          </p>
          <div className="text-center mt-2 mb-4">
            <button className="mybutton">Get in Touch</button>
          </div>
        </div>

        <div className="row">
          {/* First Column */}
          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 text-center">
            <img
              src="/images/sc5.png"
              style={{ width: "200px", height: "200px" }}
              className="img-fluid"
              alt="Discovering Your Vision"
            />
            <h6 className="mt-2">Discovering Your Vision</h6>
            <p className="text-left">
              We meet with you to discuss your vision, needs, budget, and
              timeline. This helps us understand your unique style and
              requirements.
            </p>
          </div>

          {/* Second Column */}
          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 text-center">
            <img
              src="/images/sc2.png"
              style={{ width: "200px", height: "200px" }}
              className="img-fluid"
              alt="Sketching Your Dreams"
            />
            <h6 className="mt-2">Sketching Your Dreams</h6>
            <p className="text-left">
              Based on our consultation, we create initial design concepts and
              mood boards to visualize the space and overall aesthetic.
            </p>
          </div>

          {/* Third Column */}
          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 text-center">
            <img
              src="/images/2.png"
              style={{ width: "200px", height: "200px" }}
              className="img-fluid"
              alt="Bringing Ideas to Life"
            />
            <h6 className="mt-2">Bringing Ideas to Life</h6>
            <p className="text-left">
              Once you approve the concept, we develop detailed plans, 3D
              renderings, and material selections to bring your vision to life.
            </p>
          </div>

          {/* Fourth Column */}
          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 text-center">
            <img
              src="/images/3.png"
              style={{ width: "200px", height: "200px" }}
              className="img-fluid"
              alt="Transforming Your Space"
            />
            <h6 className="mt-2">Transforming Your Space</h6>
            <p className="text-left">
              We oversee the transformation of your space, coordinating with
              contractors and managing the installation of furnishings and
              decor.
            </p>
          </div>
        </div>
      </div>

      {/* -----------------container-7------------------- */}
      <div className="container mt-4">
        <div className="row">
          <h2 className="text-center second-heading mt-2">
            Meet Our <br /> Designers
          </h2>
          <h5 className="about-heading mt-3">TEAM</h5>
          <p className="text-center mt-4">
            Our team of passionate experts transforms your vision into stunning
            and impactful designs.
          </p>
          <div className="text-center mt-2 mb-4">
            <button className="mybutton">Contact</button>
          </div>

          <div className="row client">
            {/* First Designer Image */}
            <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 text-center mb-2">
              <img
                src="/images/client3.png"
                style={{ width: "100%", height: "auto", maxWidth: "300px" }}
                alt="Designer 1"
                className="img-fluid"
              />
            </div>

            {/* Second Designer Image */}
            <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 text-center mt-4 mt-md-0">
              <img
                src="/images/client1.png"
                style={{ width: "100%", height: "auto", maxWidth: "300px" }}
                alt="Designer 2"
                className="img-fluid"
              />
            </div>

            {/* Third Designer Image */}
            <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 text-center mt-4 mt-md-0">
              <img
                src="/images/client4.png"
                style={{ width: "100%", height: "auto", maxWidth: "300px" }}
                alt="Designer 3"
                className="img-fluid"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Home;
